import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import {
  INTERVALS_GET_DAYS,
  INTERVALS_GET_INTERVALS,
  INTERVALS_GET_OFFICE_INFO,
  INTERVALS_GET_OFFICE_STATS,
  INTERVALS_SELECT_DAY,
  INTERVALS_RESET_DATA,
  PENDING, FULFILLED, REJECTED,
} from '../../globals';

import { parseDateTimeToSpecificTimezone } from '../../common/Timezones';

export function getDayRequest() {
  return {
    type: `${INTERVALS_GET_DAYS}_${PENDING}`,
  };
}

export function getDaySuccess(response) {
  return {
    type: `${INTERVALS_GET_DAYS}_${FULFILLED}`,
    payload: {
      data: getDatesInSpecificTimezone(response.data.days, response.data.timezone, ['date']),
      status: response.status,
    }
  };
}

export function getDayFailure(response) {
  return {
    type: `${INTERVALS_GET_DAYS}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}



export function getIntervalsRequest() {
  return {
    type: `${INTERVALS_GET_INTERVALS}_${PENDING}`,
  };
}

export function getIntervalsSuccess(response) {
  return {
    type: `${INTERVALS_GET_INTERVALS}_${FULFILLED}`,
    payload: {
      data: getDatesInSpecificTimezone(response.data.intervals, response.data.timezone, ['time_from', 'time_to']),
      status: response.status,
    }
  };
}

export function getIntervalsFailure(response) {
  return {
    type: `${INTERVALS_GET_INTERVALS}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}



export function getOfficeInfoServiceRequest() {
  return {
    type: `${INTERVALS_GET_OFFICE_INFO}_${PENDING}`,
  };
}

export function getOfficeInfoServiceSuccess(response) {
  return {
    type: `${INTERVALS_GET_OFFICE_INFO}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getOfficeInfoServiceFailure(response) {
  return {
    type: `${INTERVALS_GET_OFFICE_INFO}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}



export function getServiceInfoServiceRequest() {
  return {
    type: `${INTERVALS_GET_OFFICE_STATS}_${PENDING}`,
  };
}

export function getServiceInfoServiceSuccess(response) {
  return {
    type: `${INTERVALS_GET_OFFICE_STATS}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getServiceInfoServiceFailure(response) {
  return {
    type: `${INTERVALS_GET_OFFICE_STATS}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}


export function serviceSelectDay(day, dayId) {
  return {
    type: `${INTERVALS_SELECT_DAY}`,
    payload: {
      day: day,
      dayId: dayId,
    }
  };
}


export function intervalsResetData() {
  return {
    type: `${INTERVALS_RESET_DATA}`,
  };
}



export const getDays = (officeId, serviceId) => ({
  [CALL_API]: {
    actions: [getDayRequest, getDaySuccess, getDayFailure],
    url: `${API_URL}/web/days?store_id=${officeId}&service_id=${serviceId}`,
  },
});

export const getIntervals = (dayId) => ({
  [CALL_API]: {
    actions: [getIntervalsRequest, getIntervalsSuccess, getIntervalsFailure],
    url: `${API_URL}/web/intervals?day_id=${dayId}`,
  },
});

export const getOfficeInfo = (officeId) => ({
  [CALL_API]: {
    actions: [getOfficeInfoServiceRequest, getOfficeInfoServiceSuccess, getOfficeInfoServiceFailure],
    url: `${API_URL}/web/stores?id=${officeId}`,
  },
});

export const getServiceInfo = (officeId, serviceId) => ({
  [CALL_API]: {
    actions: [getServiceInfoServiceRequest, getServiceInfoServiceSuccess, getServiceInfoServiceFailure],
    url: `${API_URL}/web/services?store_id=${officeId}&id=${serviceId}`,
  },
});

/**
 * DEFAULT TIMEZONE OFFSET +1 Europe/Prague (-60 minutes) // hotfix shit with summer and winter time
 * @param {*} dates
 * @param {*} timezoneOffset
 * @param {*} parameters
 */
const getDatesInSpecificTimezone = (dates, timezone, parameters = ['date']) => {
  return dates.map((item) => {
    parameters.map((parameter) => {
      const parameterDate = new Date(item[parameter]);
      item[parameter] = parseDateTimeToSpecificTimezone(parameterDate, timezone).format();
    });
    return item;
  });
}